module.exports = __webpack_public_path__ + "static/media/unkownUser.6065f51a.svg";